<template>
  <div class="home">

    <div class="flex-align-con">
      <img src="http://meiziopen.fpv.im/company/apcs/imgs/kllogogoldblack.png" style="width:88px;height:100px;"
        alt="APCS LOGO" />
      <div class="title-text">訂單記錄</div>
    </div>

    <div v-if="isWeixin" class="wxtip">
      <img src="@/assets/wxtip.png" style="margin-right:5px;" width="180px;" alt="">
    </div>

    <div v-if="justpayed" style="margin-top:20px;padding:20px;border:1px solid #8d8555;">
      <div style="font-size:30px;">謝謝你。</div>
      <p style="margin-top:5px;">嘉霖財智已經收到上述課程的款項。課程日準時上課就可以。</p>
      <p style="margin-top:5px;">如有任何題，請於辦工時間內致電：1234 5678</p>
      <p style="margin-top:5px;">如果付款狀態未能及時更新，請稍候點擊更新按鈕更新。</p>
    </div>

    <div>
      <div style="margin-top:20px;text-align:right;">
        <Button @click="reloadClick" type="primary" size="large">
          <Icon type="md-refresh" size="16" /> 更新</Button>
      </div>
      <div v-if="orderList&&orderList.length>0">
        <div class="hairline"></div>
        <!-- <div style="margin-left:5px;margin-bottom:10px;">Orders</div> -->
        <div v-for="(item, index) in orderList" :key="index">
          <div style="margin-top:8px;"></div>
          <Card>
            <p slot="title">Order #{{item.orderid}}</p>
            <p>報讀課程：{{item.title}}</p>
            <p>老師：{{item.crouse_teacher}}</p>
            <p>時間：{{item.crouse_date}}</p>
            <p>費用：HK$ {{parseInt(item.needprice).toLocaleString()}}</p>
            <div v-if="item.payed==1||item.payed=='1'">
              <Tag color="success">已支付</Tag>
            </div>
            <div v-else style="margin-top:10px;">
              <Button @click="goPay(item)" type="info" size="large" style="margin-top:10px;">
                <Icon type="md-card" /> Pay</Button>
              <div style="font-size:80%;margin-top:4px;">付款後請耐心等待工作人員處理</div>
              <!-- <PayPal :amount="item.needprice" currency="HKD" :client="credentials"
                :invoice-number="item.orderid+'_'+Math.random().toString(36).substr(2)" :button-style="myStyle"
                @payment-authorized="paymentauthorized($event,item)"
                notify-url="https://meizi.hosti4g.com/open/api/index/paypal_done"> -->
              <!-- env="sandbox" -->
              <!-- </PayPal> -->
            </div>
          </Card>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
// import OrderItem from '@/components/OrderItem.vue'
import UserModel from './../model/UserModel'
import PayPal from 'vue-paypal-checkout'

export default {
  name: 'home',
  components: {
    // OrderItem,
    PayPal
  },
  data () {
    return {
      credentials: {
        sandbox: 'Aae55JBXqJIpMAkhJTdvhuTZYsbvSs2j4-yWf26ev0lyrz1iCm0zGbIHq6EkaZFGEfkIjIWuhRw-KUSN',
        production: 'AfWCzYCHrG3ykBTRHLomSbmy8o4mY8wBi4nwt9fREZEUOok_5Bxf7luFUOSwpqih6tiXODJREDnPJy9O'
      },
      myStyle: {
        size: 'medium',
        shape: 'pill',
        color: 'gold'
      },
      orgData: [],
      list1: [],
      list2: [],
      list3: [],
      select1: '',
      crouse_id: '',
      select3: '',
      referrer: '',
      wechat: '',
      tags: [],
      name: '',
      phone1: '',
      phone2: '',
      phone3: '',
      search_phone1: '',
      search_phone2: '',
      search_phone3: '',
      email: '',
      userid: '0',
      price: 0,
      openProfile: false,
      orderList: [],
      justpayed: false
    }
  },
  computed:
  {
    isWeixin () {
      var ua = navigator.userAgent
      var isWeixin = !!/MicroMessenger/i.test(ua)
      return isWeixin
    }
  },
  methods: {
    goPay (item) {
      window.open('https://www.petersotraining.com/payment2', '_blank');
    },
    reloadClick () {
      this.getOrdersBySearch()
    },
    paymentauthorized (e, order) {
      var that = this
      this.justpayed = true
      console.log('paymentauthorized', e, order)
      this.$Message.info({
        content: '正在刷新數據...',
        duration: 5000
      });
      setTimeout(function () {
        // window.location.reload()
        that.getOrdersBySearch()
      }, 5000)
      // this.$Message.info({
      //   content: 'Saving...',
      //   duration: 0
      // });
      // UserModel.setOrderPayed(order.orderid, e, (res) => {
      //   this.$Message.destroy()
      //   this.getOrdersBySearch()
      //   window.location.reload()
      // }, (err) => {
      //   this.$Message.destroy()
      //   this.$Message.error({
      //     content: err || 'Something error'
      //   })
      //   console.log('err', err)
      // })
    },
    getOrdersBySearch () {
      this.$Message.info({
        content: 'Loading...',
        duration: 0
      });
      UserModel.getOrdersByPhone(this.search_phone1, this.search_phone2, this.search_phone3, (res) => {
        this.$Message.destroy()
        this.orderList = res
        console.log('res', res)
      }, (err) => {
        this.openProfile = true
        this.$Message.destroy()
        this.$Message.error({
          content: err || 'Something error'
        })
        console.log('err', err)
      })

    }
  },
  mounted () {
    this.$nextTick(function () {
      console.log('$route.params', this.$route.params)
      console.log('$route.query', this.$route.query)
      this.search_phone1 = this.$route.query.phone1
      this.search_phone2 = this.$route.query.phone2
      this.search_phone3 = this.$route.query.phone3
      this.$Message.info({
        content: 'Loading...',
        duration: 0
      });
      this.getOrdersBySearch()
    })
  },
}
</script>


<style>
#app {
  background: #fff;
}

.home {
  padding: 20px;
}

.flex-align-con {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}

.title-text {
  margin-left: 5px;
  font-weight: 300;
  font-size: 41px;
  line-height: 25px;
  color: #000;
}

.select-item {
  margin-top: 10px;
}

.hairline {
  height: 1px;
  opacity: 0.5;
  background: #bebebe;
  margin: 20px -20px;
}

.black-title {
  margin: 0px -20px;
  margin-bottom: 20px;
  background: #9a9a9a;
  color: white;
  padding: 5px 20px;
}

.ivu-form-item {
  margin-bottom: 10px !important;
}

.ivu-form .ivu-form-item-label {
  font-size: 15px !important;
}

.graytip {
  font-size: 12px;
  color: #9a9a9a;
}

.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: right;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  /* display: none; */
}
</style>
